import type React from "react";

const TvConnectButtonWeb: React.FC = () => null;

export default TvConnectButtonWeb;
